import _ from "lodash";
import { DateUtils } from "../utils/DateUtils";

export class ImportMetadata {
    id?: number;
    status?: number;
    used_tokens?: number;
    files: Array<any> = [];
    created_at?: string;
    updated_at?: string;
    document_deleted_at?: string | null;

    constructor(data: any) {
        _.assign(this, _.omit(data, ["files"]));
        if (data.files) {
            this.files = data.files;
        }
    }

    // Status constants
    static readonly STATUS = {
        PENDING: 0,
        PROCESSING: 1,
        SUCCESS: 2,
        ERROR: 3,
        DUPLICATE: 4,
    };

    // Status label getter
    get status_label(): string {
        switch (this.status) {
            case ImportMetadata.STATUS.PENDING:
                return "En attente";
            case ImportMetadata.STATUS.PROCESSING:
                return "En cours d'analyse";
            case ImportMetadata.STATUS.SUCCESS:
                return this.document_deleted_at
                    ? "Analyse terminée — document supprimé le " +
                          this.document_deleted_date_str
                    : "Analyse terminée";
            case ImportMetadata.STATUS.ERROR:
                return "Erreur";
            case ImportMetadata.STATUS.DUPLICATE:
                return "Doublon — déjà analysé";
            default:
                return "Inconnu";
        }
    }

    // Date formatting getter
    get creation_date_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY");
        } else {
            return "";
        }
    }

    get creation_date_hour_str(): string {
        if (this.created_at) {
            return DateUtils.sqlToDateStr(this.created_at, "DD/MM/YYYY HH:mm");
        } else {
            return "";
        }
    }

    // Suppression manuelle de la fiche issue de cette analyse (le document
    // renvoyé par mail sera de nouveau analysé).
    get document_deleted_date_str(): string {
        if (this.document_deleted_at) {
            return DateUtils.sqlToDateStr(
                this.document_deleted_at,
                "DD/MM/YYYY"
            );
        } else {
            return "";
        }
    }

    // Serialize method for API calls
    serialize(): ImportMetadata.IImportMetadata {
        return {
            id: this.id,
            status: this.status,
            used_tokens: this.used_tokens,
        };
    }
}

// Interface for serialization
export namespace ImportMetadata {
    export interface IImportMetadata {
        id?: number;
        status?: number;
        used_tokens?: number;
    }
}
